import React from "react";
import { Create, FileInput, FileField, SimpleForm, TextInput, required, useNotify, useRedirect } from "react-admin";
const ImportThematicCatalogs = props => {
  const notify = useNotify();
  const redirect = useRedirect();
  const onSuccess = data => {
    notify(`Файлът е качен успешно!`, { type: "success" });
    redirect(`/editions`);
  };
  const onError = error => {
    notify(` ${error.message}`, { type: "error" });
  };
  return (
    <Create
      mutationOptions={{ onSuccess, onError }}
      title="Импортиране на тематичен каталог"
    >
      <SimpleForm>
        <TextInput
          label="Име на тематичен каталог"
          source="name"
          validate={required()}
          sx={{ width: "70%" }}
        />
        <FileInput
          placeholder="Добавете файл с теми в XLS формат"
          label="Теми"
          source="file"
          accept=".xls , .xlsx"
        >
          <FileField
            source="src"
            title="title"
            label={null}
          />
        </FileInput>
      </SimpleForm>
    </Create>
  );
};

export default ImportThematicCatalogs;
